// frontend/modules/account-settings/routes.tsx
import { RouteObject } from 'react-router-dom';
import { CashBankManagement } from './views/CashBankManagement';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';

export const accountSettingsRoutes: RouteObject[] = [
    {
        path: '/Admin/account-settings/define-cash-cheque-transfer-accounts',
        element: <CashBankManagement />,
        errorElement: <ErrorBoundary />
    }
];